import React from 'react';
import Tooltip from '../tooltip/Tooltip';

export interface IDotProps {
  hoverText: string;
  color: 'red' | 'green' | 'gray' | 'darkblue';
  paddingSide?: 'left' | 'right';
  halfFilled?: boolean;
  tooltipDirection?: 'top' | 'bottom' | 'left';
  showTooltip?: boolean;
}

export const Dot: React.FC<IDotProps> = ({
  color,
  hoverText,
  paddingSide,
  halfFilled = false,
  tooltipDirection = 'top',
  showTooltip = true,
}) => {
  const dotElement = (
    <div className={`react-dot-wrapper ${getPadding(paddingSide)}`}>
      <span
        className={`react-dot
                                  dot-${color}
                                  dot-${halfFilled ? 'half' : 'full'}-circle`}></span>
    </div>
  );

  return showTooltip ? (
    <Tooltip tooltipText={hoverText} appearOnSide={tooltipDirection}>
      {dotElement}
    </Tooltip>
  ) : (
    dotElement
  );
};

const getPadding = (paddingSide) => {
  switch (paddingSide) {
    case 'left':
      return 'dot-left-padding';
    case 'right':
      return 'dot-right-padding';
    default:
      return 'dot-full-padding';
  }
};
